module.exports = __webpack_public_path__ + "media/src/assets/images/sprite-icons-c24b11410eb3c1f315c562a835238bb4.svg";